import * as types from '../mutation-types';

// const TEST_PERMISSIONS = [
//   'rolesView',
//   'rolesManage',
//   'usersView',
//   'usersManage',
//   'operationsView',
//   'operationsManage',
//   'receivedSamplesView',
//   'receivedSamplesDownload',
//   'receivedSamplesManage',
//   'workPlanningManage',
//   'quarantineView',
//   'quarantineManage',
//   'analysesDataView',
//   'analysesDataManage',
//   'analysesStatusView',
//   'analysesStatusManage',
//   'analysesWorkPlanningView',
//   'analysesWorkPlanningManage',
//   'printReportManage',
//   'printAnalysesManage',
//   'searchManage',
// ];

const initialState = {
  loggedUser: null,
};

const usersState = { ...initialState };

const getters = {
  loggedUser: (state) => state.loggedUser,
  userPermissions: (state) =>
    (state.loggedUser && state.loggedUser.permissions) || null,
  // userLab: (state) => (
  //   (state.loggedUser
  //     && state.loggedUser.currentRole
  //     && state.loggedUser.currentRole.laboratory) || null
  // ),
  // availableLabs: (state) => state.loggedUser.roles.map((r) => r.laboratory),
};

const actions = {
  setLoggedUser({ commit }, user) {
    commit(types.SET_USER, user);
  },
};

const mutations = {
  [types.SET_USER](state, user) {
    state.loggedUser = user;
  },
};

export default {
  state: usersState,
  getters,
  actions,
  mutations,
};
